(function() {
  function toggleCard(card, button) {
    var isClosed = card.classList.toggle('is-closed');
    button.textContent = isClosed ? 'Open' : 'Close';
    button.setAttribute('aria-expanded', String(!isClosed));
  }

  function toggleOfferItem(item, button) {
    var isOpen = item.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(isOpen));
  }

  function copyOfferCode(button) {
    var code = button.getAttribute('data-copy-offer-code');
    if (!code) return;
    navigator.clipboard.writeText(code).catch(function() {});
    button.textContent = 'Copied';
    setTimeout(function() {
      button.textContent = 'Copy Code';
    }, 1200);
  }

  function initOffersCard(card) {
    var cardToggleButton = card.querySelector('[data-offers-card-toggle]');
    if (cardToggleButton) {
      cardToggleButton.addEventListener('click', function() {
        toggleCard(card, cardToggleButton);
      });
    }

    card.addEventListener('click', function(event) {
      var offerToggleButton = event.target.closest('[data-offer-toggle]');
      if (offerToggleButton) {
        toggleOfferItem(offerToggleButton.closest('[data-offer-item]'), offerToggleButton);
        return;
      }

      var copyButton = event.target.closest('[data-copy-offer-code]');
      if (copyButton) {
        copyOfferCode(copyButton);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    var cards = document.querySelectorAll('[data-offers-card]');
    if (!cards.length) return;
    cards.forEach(initOffersCard);
  });
})();
